import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FlexLayoutModule } from '@ngbracket/ngx-layout'
import { ReactiveFormsModule } from '@angular/forms'

import { MaterialModule } from '../material/material.module'
import { TranslateModule } from '@ngx-translate/core'

import { FormFieldErrorComponent } from './form-field-error/form-field-error.component'
import { FormSubmitButtonComponent } from './form-submit-button/form-submit-button.component'
import { FormSubmitButtonUpdComponent } from './form-submit-button-upd/form-submit-button-upd.component'

@NgModule({
  declarations: [FormFieldErrorComponent, FormSubmitButtonComponent, FormSubmitButtonUpdComponent],
  imports: [CommonModule, MaterialModule, FlexLayoutModule, ReactiveFormsModule, TranslateModule.forChild()],
  exports: [FormFieldErrorComponent, FormSubmitButtonComponent, FormSubmitButtonUpdComponent],
})
export class WidgetsModule {}
